var maratonWarszawski = new NinjaWeb();
maratonWarszawski.showSubMenu({select: '.menu-item-has-children'});

function initSponorSlider(config) {

	var sponsorSlider = jQuery( config.sponsorSliderSelector ),
		sliderInterval = sponsorSlider.attr('data-slide-interval'),
		slidesWrapper = sponsorSlider.find('.sponsor-bar__slides-wrapper'),
		slides = sponsorSlider.find('.sponsor-bar__slide');

	if(!sponsorSlider.length || !slides.length) return;

	prepareSlidesPosition(slides);

	sponsorSlider.height( jQuery(slides[0]).height() );

	jQuery(window).on('resize', function () {
		sponsorSlider.height( jQuery(slides[0]).height() );
	});

	var activeSlideIndex = 0;

	setInterval(function () {

		if(activeSlideIndex === slides.length - 1) {
			slidesWrapper.css('left', 0);
			activeSlideIndex = 0;
		} else {
			slidesWrapper.css('left', '-' + ++activeSlideIndex + '00%');
		}

	}, sliderInterval);

}

function prepareSlidesPosition(slides) {

	slides.each(function (i, e) {
		e = jQuery(e);
		e.css('left', i + '00%');
	});

}

jQuery(document).ready(function() {

	jQuery('#odlotowy-form input[type="submit"]').on('click', function () {
		jQuery('.reponse-message').slideUp();
	});

	jQuery('#odlotowy-form').on('submit', function (e) {

		e.preventDefault();

		var that = jQuery(this),
			data = {
				'firstname': that.find('input[name=firstname]').val(),
				'lastname': that.find('input[name=email]').val(),
				'number': that.find('input[name=number]').val(),
				'email': that.find('input[name=email]').val()
			},
			responseContainer = jQuery('.reponse-message');


		jQuery.ajax({
			type: 'POST',
			url: that.data('ajax-target'),
			data: data,
			dataType: 'json'
		})
			.done(function (response) {
				console.log(response);
				that.find('input:not([type=submit])').val('');
				that.find('input[type=checkbox]').attr('checked', false);
				responseContainer.text('Zgłoszenie zostało zapisane pomyślnie. Dziękujemy.').css('color', 'green').slideDown(200);
			})
			.fail(function (jqXHR, textStatus, errorThrown) {
				console.log(textStatus + ': ' + errorThrown);
				responseContainer.text('Wystąpił błąd. Skontaktuj się z info@maratonwarszawski.com, aby rozwiązać problem.').css('color', 'red').slideDown(200);
			})

	});

    jQuery(".youtube").colorbox({iframe:true, innerWidth:640, innerHeight:390});
    jQuery(".inline").colorbox({inline:true, width:"50%"});

    if(jQuery(window).width() < 992) jQuery(".inline").colorbox({inline:true, width:"90%"});

    jQuery(window).on('resize', function(){
        if(jQuery(window).width() < 992) jQuery(".inline").colorbox({inline:true, width:"90%"});
    });


      jQuery('.lang-switcher').click(function() {
          jQuery('.drop-lang').toggleClass('show-lang');
      });



    setTimeout(function(){
        jQuery('.container__news-and-kalendarium .news-list .news-wrapper').css('height', jQuery('.slide-wrapper').height() - 100);
        jQuery('.container__news-and-kalendarium .news-list').css('height', jQuery('.slide-wrapper').height());
        jQuery( window ).resize(function() {
            jQuery('.container__news-and-kalendarium .news-list .news-wrapper').css('height', jQuery('.slide-wrapper').height() - 100);
            jQuery('.container__news-and-kalendarium .news-list').css('height', jQuery('.slide-wrapper').height());
        });
    }, 100)


    // disable links
    jQuery('.menu-column > a').click(function(e) {
        e.preventDefault();
    });

    jQuery('#menu-main-menu a').click(function(e) {
        if (/#/.test(this.href)) {
            e.preventDefault();
        }
    });

    // colorbox init
    jQuery('a.gallery').colorbox({rel: 'gallery', maxHeight: '90%', title: function(){
        var url = jQuery(this).attr('href');
        return '<a href="' + url + '" target="_blank">Otwórz w nowym oknie</a>';
    }});
    jQuery('.gallery-icon a').colorbox({rel: 'gallery', maxHeight: '90%', title: function(){
        var url = jQuery(this).attr('href');
        return '<a download href="' + url + '" target="_blank">Pobierz foto</a>';
    }});

    // init gallery app
    if(jQuery('.fmw-gallery').length) {
    //    maratonGallery.initGal();
    }

    // facebook widget
    jQuery('.efka').click(function () {
       jQuery('.facebook-page-container').toggleClass('fb-show');
    });

    // search functions
    jQuery('.searchbox').click(function () {
        jQuery('.search-overlay').toggleClass('show-overlay');
        jQuery('.fixed-search-bar').toggleClass('search-bar-show');
        jQuery('.fa-search', this).toggleClass('fa-close');
    });

    jQuery('.search-overlay').click(function () {
        jQuery('.search-overlay').toggleClass('show-overlay');
        jQuery('.fixed-search-bar').toggleClass('search-bar-show');
        jQuery('.fa-search').toggleClass('fa-close');
    });

    // init scroll bar
    jQuery('.news-list .news-wrapper, .kalendarium-list .news-wrapper').perfectScrollbar();

    // init tooltip
    jQuery('[data-toggle="tooltip"]').tooltip();

    jQuery('img[usemap]').rwdImageMaps();

    jQuery('.menu-rwd').click(function () {
        jQuery('#main-nav').stop().toggleClass('target');
        jQuery('body').stop().toggleClass('open-rwd');
        jQuery('.facebook-page-container').stop().toggleClass('hidden-xs');
    });

    //if(jQuery('body').hasClass('polmaraton-site')) {
    //    maratonProjekty.getData();
    //    setInterval(function(){ maratonProjekty.getData(); }, 60000);
    //}

	jQuery(window).load(function() {
		initSponorSlider({ sponsorSliderSelector: '#sponsor-bar-slider' });
	});

});


var maratonProjekty = {
    getData: function (url) {
        jQuery.ajax({
            method: "GET",
            url: url,

        }).done(function (msg) {
            jQuery("#js-sum").text(msg.sum);
            jQuery("#js-total").text(msg.total);
        });
    }
};

var maratonGallery = {
    initGal: function (min, max) {
        var originalVal;

        jQuery("#ex16b").slider({
            min: min, max: max, value: max, scale: 'logarithmic', step: 1
        }).on(
            'slideStart', function (ev) {
                originalVal = jQuery('#ex16b').data('slider').getValue();
            }
        );

        jQuery("#ex16b").slider().on(
            'slideStop', function (ev) {
                var newVal = jQuery('#ex16b').data('slider').getValue();
                //console.log(newVal+' '+originalVal);
                if (originalVal != newVal) {
                    jQuery(".mobile-label").text(ev.value);
                    jQuery('#gallery-widget').css({opacity: 0.5});
                    jQuery('.sk-cube-grid').show();
                    maratonGallery.asyncGet(newVal);

                }
            }
        );
        maratonGallery.bindActionButtons();
    },
    getGalleryPage: function (page, init) {
        var yerVal = jQuery('#ex16b').data('slider').getValue();
        jQuery('#gallery-widget').css({opacity: 0.5});
        jQuery('.sk-cube-grid').show();
        if(init) {
            maratonGallery.asyncGetInit(page);
        } else {
            maratonGallery.asyncGet(yerVal, page);
        }

    },
    bindActionButtons: function (init) {
        jQuery('#gallery-widget .next, #gallery-widget .prev').click(function (e) {
            e.preventDefault();
            var link = this.href;
            var arrayLink = link.split('=');
            var docelowy = arrayLink[arrayLink.length - 1];
            if(init) {
                maratonGallery.getGalleryPage(docelowy);
            } else {
                maratonGallery.getGalleryPage(docelowy);
            }

        });
    },
    asyncGet: function (newVal, page) {
        if (!page) page = 1;
        async.series([
            function (callback) {
                jQuery.ajax({
                    method: "GET",
                    url: "/",
                    data: {value: newVal, cpage: page}

                }).done(function (msg) {
                    var newGallery = jQuery(msg).find('#gallery-widget');
                    jQuery('#gallery-widget').replaceWith(newGallery);
                    callback(null, 2);
                });
            },
            function (callback) {
                maratonGallery.colorBoxInit();
                callback(null, {colorbox: true});
            }
        ], function (error, results) {
            jQuery('.sk-cube-grid').hide();
            maratonGallery.bindActionButtons();
        });
    },
    asyncGetInit: function (page) {
        if (!page) page = 1;
        async.series([
            function (callback) {
                jQuery.ajax({
                    method: "GET",
                    url: "/",
                    data: {cpage: page}

                }).done(function (msg) {
                    var newGallery = jQuery(msg).find('#gallery-widget');
                    jQuery('#gallery-widget').replaceWith(newGallery);
                    callback(null, 2);
                });
            },
            function (callback) {
                maratonGallery.colorBoxInit();
                callback(null, {colorbox: true});
            }
        ], function (error, results) {
            jQuery('.sk-cube-grid').hide();
            maratonGallery.bindActionButtons(true);
        });
    },
    colorBoxInit: function () {
        jQuery('a.gallery').colorbox({rel: 'gallery', maxHeight: '90%', title: function(){
            var url = jQuery(this).attr('href');
            return '<a href="' + url + '" target="_blank">Otwórz w nowym oknie</a>';
        }});
        jQuery('.gallery-icon a').colorbox({rel: 'gallery', maxHeight: '90%', title: function(){
            var url = jQuery(this).attr('href');
            return '<a download href="' + url + '" target="_blank">Pobierz foto</a>';
        }});
        jQuery(".youtube").colorbox({iframe:true, innerWidth:640, innerHeight:390});
        jQuery(".inline").colorbox({inline:true, width:"50%"});
    }

};

console.log('test deplpy');
